import axios from 'axios';
import Sentry from './sentry';

const fetchData = async () => {
  try {
    // eslint-disable-next-line no-undef
    const { data } = await axios.get(process.env.GATSBY_API_URL, {
      headers: {
        //Authorization: 'Basic Y3Y6ODZLKkZ0c2EqcUt0RUE=',
      },
    });
    return data;
  } catch (error) {
    console.error('Error on updating from API');
    Sentry.captureException(error);
    return [];
  }
};

const fetchStatus = async () => {
  try {
    const params = {
      empresa: 86,
      cadena: 10,
      local: [{
        n: -1,
      }],
    };

    // eslint-disable-next-line no-undef
    const { data } = await axios.post(process.env.GATSBY_API_STATUS_URL, params, {
      headers: {
        'Content-Type': 'application/json',
        'X-IBM-Client-Id': process.env.GATSBY_API_CLIENT_ID,
      },
    });
    return data;
  } catch (error) {
    console.error('Error on updating statuses from API');
    Sentry.captureException(error);
    return [];
  }
};

export {
  fetchData,
  fetchStatus,
};
